<template>
  <footer class="footer footer--6">
    <div class="container">
      <logo></logo>
      <footer-nav></footer-nav>
      <contacts></contacts>
      <div class="footer__info">
        <copyright></copyright>
        <paysistems></paysistems>
      </div>
    </div>
  </footer>
</template>

<script>
  import Logo from "./parts/Logo.vue";
  import Slogan from "./parts/Slogan.vue";
  import FooterNav from "./parts/FooterNav.vue";
  import Contacts from "./parts/Contacts.vue";
  import Paysistems from "./parts/Paysistems.vue";
  import Copyright from "./parts/Copyright.vue";

  export default {
    components: {
      Logo,
      Slogan,
      FooterNav,
      Contacts,
      Paysistems,
      Copyright,
    },
  };
</script>

<style lang="scss">
  .footer--6 {
    &.footer {
      background-color: $dark-color;
      padding: 40px 0;
      .footer__logo {
        max-width: 162px;
        margin: 0 auto 40px auto;
      }
      .footer__menu {
        text-align: center;
        li {
          display: inline-block;
          padding: 0 20px;
          a {
            color: $white-color;
            &:hover {
              color: $accent-color-light;
            }
          }
        }
      }
      .footer__contacts {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 40px;
        margin: 40px 0;
        color: $white-color;
        a {
          color: $white-color;
          &:hover {
            color: $accent-color-light;
          }
        }
      }
      .footer__info {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .footer__copyright {
        color: $white-color;
        opacity: 0.5;
      }
      .footer__paysistems {
        display: flex;
        gap: 12px;
      }
      @media (max-width: $breakpoint-lg) {
        .footer__contacts {
          flex-direction: column;
          align-items: center;
          gap: 16px;
          text-align: center;
        }
      }
      @media (max-width: $breakpoint-md) {
        .footer__menu {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
          li {
            display: block;
            padding: 0;
          }
        }
        .footer__info {
          flex-direction: column;
          gap: 16px;
          text-align: center;
        }
      }
    }
  }
</style>
